export function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== 'undefined';
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/isNodeList.js